var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isRequestingModifiers
        ? _c(
            "section",
            [
              _c("spinner-loader", {
                attrs: { loading: _vm.isRequestingModifiers },
              }),
            ],
            1
          )
        : _vm.taxesAndFees.length < 1
        ? _c(
            "section",
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modifierModal",
                      modifiers: { modifierModal: true },
                    },
                  ],
                  staticStyle: { "margin-top": "4px" },
                },
                [_vm._v("New Tax")]
              ),
            ],
            1
          )
        : _c(
            "section",
            [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    {
                      staticClass: "search-header",
                      attrs: { "align-h": "center" },
                    },
                    [
                      _c(
                        "b-col",
                        { staticClass: "my-1", attrs: { md: "6" } },
                        [
                          _c(
                            "b-input-group",
                            [
                              _c("b-form-input", {
                                attrs: { placeholder: _vm.$t("search") },
                                model: {
                                  value: _vm.filter,
                                  callback: function ($$v) {
                                    _vm.filter = $$v
                                  },
                                  expression: "filter",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { md: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.modifierModal",
                                  modifiers: { modifierModal: true },
                                },
                              ],
                              staticStyle: { "margin-top": "4px" },
                            },
                            [_vm._v("New Tax")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.isLoading
                ? _c("b-table", {
                    ref: "modsTable",
                    staticClass: "modifier-table",
                    attrs: {
                      items: _vm.taxesAndFees,
                      fields: _vm.fields,
                      filter: _vm.filter,
                      hover: "",
                      striped: "",
                      fixed: "",
                    },
                    on: { "row-clicked": _vm.rowClicked },
                  })
                : _c(
                    "div",
                    { staticClass: "fixed-center" },
                    [_c("spinner-loader")],
                    1
                  ),
            ],
            1
          ),
      _vm._v(" "),
      _c("modifier-modal", {
        ref: "modifierModal",
        on: { submit: _vm.submitModifier, delete: _vm.deleteModifier },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n      You don't have any modifiers in your inventory yet. "),
      _c("br"),
      _vm._v('Create your\n      first one by clicking "New Modifier."\n    '),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }